import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { ProvidersAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"


export default function ReportProvidersField() {
	const {
		filterProviders,
		setFilterProvidersInfo,
		error
	} = useReportFormInfo(reportFormData.peek().filterProviders, "filterProviders", object({ filterProviders: array().nullable() }))

	return <ProvidersAutocomplete
		value={filterProviders}
		onChange={e => setFilterProvidersInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/provider`}
	/>
}